// extracted by mini-css-extract-plugin
module.exports = {"main":"debug-transaction_main__2M5Az","header":"debug-transaction_header__1LTqz","pending":"debug-transaction_pending__2VZKL","container":"debug-transaction_container__2Zp1c"};